import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-geographic-details',
  templateUrl: './modal-geographic-details.component.html',
  styleUrls: ['./modal-geographic-details.component.scss']
})
export class ModalGeographicDetailsComponent {
  @Input() showModal = false;
  @Input() invoiceData: any = null;
  @Output() closed = new EventEmitter<void>();

  closeModal(modal: any) {
    this.showModal = false;
    this.closed.emit();
  }

  getTotal(): number {
    if (!this.invoiceData?.details) return 0;
    return this.invoiceData.details.reduce((sum: number, d: any) => sum + d.price * d.quantity, 0);
  }

  formatDate(ms: number): string {
    if (!ms) return '';
    const date = new Date(ms);
    return date.toLocaleString();
  }
}
